module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-pagination"
  }, [_c('div', {
    staticClass: "pages"
  }, [_c('div', {
    staticClass: "page page-previous",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onPreviousPage.apply(null, arguments)
      }
    }
  }, [_vm._v("«")]), _vm._l((_vm.pages), function(page) {
    return _c('div', {
      staticClass: "page",
      class: _vm.pageClasses(page),
      domProps: {
        "innerHTML": _vm._s(page)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.setPage(page)
        }
      }
    })
  }), _c('div', {
    staticClass: "page page--next",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onNextPage.apply(null, arguments)
      }
    }
  }, [_vm._v("»")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57fa06d3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ansergy-datatable/table-pagination.vue
// module id = 272
// module chunks = 1